import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: LocationCoordinates = { latitude: -37.8136, longitude: 144.9631 }; // melbourne

const slice = createSlice({
  name: 'fallbackLocation',
  initialState: initialState,
  reducers: {
    setFallbackLocation(state, action: PayloadAction<LocationCoordinates>) {
      return action.payload || initialState;
    },
  },
});

export const { setFallbackLocation } = slice.actions;

export default slice.reducer;
